import React, { FC, memo, useMemo } from 'react';
import { Progress, Tag } from 'udesk-ui';
import styled from 'styled-components';

const Wrapper = styled.div`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: center;

    .udesk-qa-ui-tag {
        margin: 0;
    }
`;

const Title = styled.div`
    white-space: pre-wrap;
`;

interface TemplateProps {
    label?: string;
    score?: number;
    totalScore?: number;
}

const Template: FC<TemplateProps> = memo((props) => {
    const { label, score = 0, totalScore = 0 } = props;

    const percent = useMemo(() => {
        if (totalScore === 0) {
            return 0;
        }
        return (score / totalScore) * 100;
    }, [score, totalScore]);

    return (
        <Wrapper>
            <Progress
                type="circle"
                percent={percent}
                width={50}
                format={() => `${score}分`}
                trailColor="rgb(231, 231, 231)"
            />

            <Title>{label}</Title>

            <Tag>
                <span style={{ color: '#999', fontWeight: 'normal' }}>总分{totalScore}</span>
            </Tag>
        </Wrapper>
    );
});

export default Template;
